<template>
  <div class="container containerManage mt10 ml10 mr10">
    <div class="handle_box mt10">
      <span class="fz14 c6">区域名称：</span>
      <el-cascader v-model="query.city" clearable placeholder="请选择区域" style="width:220px;margin: 0 5px;"
        :options="cityList" :props='props' clearable filterable>
      </el-cascader>
      <span class="fz14 c6 ml10">项目名称：</span>
      <el-input v-model.trim="query.projectName" clearable placeholder="项目名称" class="handle-input "
        style="width:160px;margin: 0 5px;">
      </el-input>
      <span class="fz14 c6 ml10 ">维保单编号：</span>
      <el-input v-model.trim="query.number" clearable placeholder="维保单编号" class="handle-input "
        style="width:160px;margin: 0 5px;">
      </el-input>
    </div>
    <div class="handle_box">
      <span class="fz14 c6">空调编号：</span>
      <el-input v-model.trim="query.deviceNumber" clearable placeholder="空调编号" class="handle-input "
        style="width:160px;margin: 0 5px;">
      </el-input>
      <span class="fz14 c6 ml10 ">维修状态：</span>
      <el-select v-model="query.status" clearable placeholder="请选择" style="width:160px">
        <el-option v-for="(item,index) in typeList" :key="index" :label="item.dictValue" :value="item.dictKey">
        </el-option>
      </el-select>
      <span class="fz14 c6 ml10">安装地址：</span>
      <el-input v-model.trim="query.address" placeholder="安装地址" class="handle-input "
        style="width:160px;margin: 0 5px;">
      </el-input>
      <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click="getPage">查询</el-button>
      <el-button type="primary" size="small" class="ml10" icon="el-icon-refresh" @click="reset"
        style="background:rgba(255, 131, 85, 1);border:rgba(255, 131, 85, 1)">重置</el-button>
      <el-button type="primary" size="small" class=" ml10" v-if="permission.sys_maintain_add" icon="el-icon-circle-plus-outline" @click="repairHandle">报修
      </el-button>
    </div>
    <div class="tableData">
      <el-table :data="tableData" border class="table" style="width: 100%;" ref="multipleTable"
        header-cell-class-name="table-header">
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column v-for="(item,index) in column" align="center" :prop='item.prop' :label="item.label"
          :width="item.width" :key="index"> </el-table-column>
        <el-table-column label="操作" width="330" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==1" type="text" icon="el-icon-edit" @click="distriHandle(scope.row)">派单
            </el-button>
            <el-button type="text" icon="el-icon-document" v-if="permission.sys_maintain_record" @click="recordHandle(scope.row)">记录</el-button>
            <el-button v-if="scope.row.status!=3&&scope.row.status!=5 &&permission.sys_maintain_edit " type="text" icon="el-icon-edit"
              @click="mainHandle(scope.row)">维保</el-button>
            <el-button v-if="scope.row.status!=3&&scope.row.status!=5&&permission.sys_maintain_del" type="text" icon="el-icon-delete"
              style="color:red" @click="deleteHandle(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align:end;margin-top:12px">
        <el-pagination  @current-change="handleCurrentChange" :current-page.sync="query.current"
          :page-size="query.size" layout="total, prev, pager, next" :total="totals">
        </el-pagination>
      </div>
    </div>
    <el-dialog class="dialog_box" :title="dialogType" :visible.sync="DialogVisible" width="40%" :before-close='close'
      center>
      <div class="top" v-if="dialogType=='维保单处理'">
        <div class="top_item">
          <el-form :model="form" ref="form">
            <el-form-item label="维保状态：" :label-width="formLabelWidth" style="width:50%">
              <el-select v-model="form.status" clearable placeholder="请选择" style="width:160px">
                <el-option v-for="(item,index) in typeList.slice(2)" :key="index" :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维保处理凭据：" :label-width="formLabelWidth">
              <el-upload :data="ossParams" :action="host" list-type="picture-card" :on-success="handleAvatarSuccess"
                :on-remove="handleRemove" :before-upload="beforeUpload" :limit="limit" :on-exceed="exceed" ref="upload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="维保信息：" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="form.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top" v-if="dialogType=='派单'">
        <div class="top_item">
          <span>负责人选择：</span>
          <el-select v-model="userName" clearable placeholder="请选择负责人" @change="changeUser">
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="top_item">
          <span>联系方式：</span>
          <span>{{phone}}</span>
        </div>
      </div>
      <div>
        <div class="title">
          <div class="icon1"></div>
          <div class="icon2"></div>
          <div>用户报修信息</div>
        </div>
        <div class="wrapper1" v-for="(item,index) in userReport" :key='index'>
          <div class="item">项目名称：{{item.projectName}}</div>
          <div class="item">楼号：{{item.towerNumber}}</div>
          <div class="item">梯号：{{item.stairsNumber}}</div>
          <div class="item">报修内容：{{item.repairReason}}</div>
        </div>
      </div>
      <div v-if="dialogType=='维保单处理记录'">
        <div class="title">
          <div class="icon1"></div>
          <div class="icon2"></div>
          <div>维保记录信息</div>
        </div>
        <div class="wrapper2" v-for="(item,index) in mainRecord" :key='index'>
          <div class="item">维修状态：{{item.statusValue}}</div>
          <div class="item">记录时间：{{item.createTime}}</div>
          <div class="item">维保备注：{{item.remark}}</div>
          <div class="item">
            <span>维保处理凭据：</span>
            <div v-if="item.disposePic!=''">
              <el-image v-for="(v,h) in item.disposePic" :key='h' class="item_img" :src="v" :preview-src-list="[v]"
                fit="fill">
              </el-image>
            </div>
          
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer flex row vertical-center">
        <el-button class="button--cancel" size="small" @click="close">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <mainRepair :DialogVisible2="DialogVisible2" :dialogType='dialogType' @close2="close2" ref="mainRepair">
    </mainRepair>
  </div>
</template>
<script>
import { citysList, typeList, tableData, getUserList, assignDutyUser, recordById, tlMaintenance, maintenanceDelete } from '@/api/complexManage/mainManage.js';
import { onenet } from '@/api/onenet.js';
import { mapGetters } from 'vuex';
import DictVertical from '../util/demo/dict-vertical.vue';
import mainRepair from './mainRepair.vue'
// import { delete } from 'vue/types/umd';
export default {
  name: 'mainManage',
  components: {
    mainRepair
  },
  data() {
    DictVertical
    return {
      currentPage: 1,
      totals: 0,
      pageSize: 1,
      // 区域列表
      cityList: [],
      props: {
        label: 'title',
        value:"title"
      },
      //状态
      typeList: [],
      query: {
        city: '',
        projectName: '',
        number: '',
        deviceNumber: '',
        status: '',
        address: '',
        current: 1,
        size: 10
      },
      column: Object.freeze([
        { prop: 'projectName', label: '项目名称' },
        { prop: 'address', label: '安装地址' },
        { prop: 'number', label: '维保单编号' },
        { prop: 'statusValue', label: '维修状态' },
        { prop: 'dutyUserName', label: '负责人' },
        { prop: 'createTime', label: '报修时间' },
        { prop: 'maintenanceTime', label: '最新维保时间' },
      ]),
      tableData: [],
      // 报修弹窗
      DialogVisible2: false,
      // 其余弹窗
      // OSS相关
      host: 'http://thingcom-dianliuji.oss-cn-hangzhou.aliyuncs.com',
      ossParams: {
        OSSAccessKeyId: '',
        policy: '',
        signature: '',
        expire: '',
        key: '', // key后面有用，先默认设空字符串
        success_action_status: '200' // 默认200
      },
      limit: 10,
      imageUrl: '',
      //
      formLabelWidth: '110px',
      DialogVisible: false,
      dialogType: '新增',
      dialogImageUrl: '',
      form: {
        id: '',
        dutyUserId: '',
        disposePic: '',
      },
      //维保处理
      rules: [],
      // 派单相关
      userList: [],
      userName: '',
      phone: '',
      //维保记录
      userReport: [],
      mainRecord: [],
    }
  },
  computed: {
    ...mapGetters(['permission'])
  },
  created() {
    this.getCity()
    this.getType()
    this.getPage()
  },
  mounted() { },
  methods: {
    init() {
      this.form = {
        disposePic:''
      }
      this.getPage()
    },
    // 查询区域级联列表
    getCity() {
      let obj = { parentCode: '33' }
      citysList().then(res => {
        if (res.data.code == 200) {
          this.cityList = res.data.data
        }
      })
    },
    // 查询类型列表
    getType() {
      let obj = { code: 'maintenance_status' }
      typeList(obj).then(res => {
        if (res.data.code == 200) {
          this.typeList = res.data.data[0].children
        }
      })
    },
    // 查询表格
    getPage() {
      if (this.query.city) {
        this.query.city = this.query.city[1]
      }
      tableData(this.query).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records
          this.totals = res.data.data.total
          this.pageSize = res.data.data.pages
        }
      })
    },
    reset() {
      this.query = {
        city: '',
        projectName: '',
        number: '',
        deviceNumber: '',
        status: '',
        address: '',
        current: 1,
        size: 10
      }
      this.getPage()
    },
    handleCurrentChange(val) {
    
      this.query.current = val
      this.getPage()
    },
    // 操作相关
    // 报修
    repairHandle() {
      this.dialogType = '报修'
      this.DialogVisible2 = true
    },
    // 用户报修和维保记录信息
    getRecordById(row) {
      recordById({ id: row.id }).then(res => {
        if (res.data.code == 200) {
          this.userReport = res.data.data.maintenanceDevice
          for (let item of this.userReport) {
            item.projectName = row.projectName
          }
          this.mainRecord = res.data.data.maintenanceRecord
          for (let item of this.mainRecord) {
            item.disposePic = item.disposePic.split(';')
          }
        }
      })
    },
    // 派单
    distriHandle(row) {
      this.dialogType = '派单'
      this.form.id = row.id
      getUserList().then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data
        }
      })
      this.getRecordById(row)
      this.DialogVisible = true

    },
    changeUser(val) {
      this.userName = val.name
      this.phone = val.phone
      this.form.dutyUserId = val.id
    },
    // 维保记录
    recordHandle(row) {
      this.dialogType = '维保单处理记录'
      this.getRecordById(row)
      this.DialogVisible = true
    },
    // 维保处理
    mainHandle(row) {
      this.dialogType = '维保单处理'
      this.form.id = row.id
      this.getRecordById(row)
      this.DialogVisible = true
    },

    // 删除
    deleteHandle(scope) {
      this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        maintenanceDelete({ id: scope.id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.getPage()
          }
        })
      })

    },

    // 弹窗相关

    // 删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 提交表单
    handleSubmit() {
      let obj = {}
      if (this.dialogType == '派单') {
        let { id, dutyUserId } = this.form
        obj = { id, dutyUserId }
        assignDutyUser(obj).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
             this.getPage()
          }
        })
      } else if (this.dialogType == '维保单处理') {
        let { id, dutyUserId } = this.form
        let { id: maintenanceId, status, disposePic, remark } = this.form
        obj = { status, disposePic, remark, maintenanceId }
        tlMaintenance(obj).then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.getPage()
          }
        })
      }
      this.close()
    },
    // 获取oss签名数据
    backOssInfo: function (file) {
      let fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      return new Promise(
        function (resolve, reject) {
          onenet.ossInfo().then(
            function (response) {
              if (response === undefined) {
                this.$message.error(response.error);
                reject();
              } else {
                this.ossParams.OSSAccessKeyId = response.accessid;
                this.ossParams.policy = response.policy;
                this.ossParams.signature = response.signature;
                this.ossParams.key = sessionStorage.getItem('userId') + this.randomWord(true, 9, 12) + '.' + fileName;
                resolve();
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    randomWord(randomFlag, min, max) {
      let str = '';
      let range = min;
      let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (let i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },
    exceed(files, fileList) {
      this.$message.error('最多只能上传一个头像！');
    },
    handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.imageUrl = this.host + '/' + this.ossParams.key
      if (this.form.disposePic.length == 0) {
        this.form.disposePic = `${this.host}/${this.ossParams.key}`
      } else {
        this.form.disposePic += `;${this.host}/${this.ossParams.key}`
      }

    },
    beforeUpload: async function (file) {
      await this.backOssInfo(file);
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt1M) {
        this.$message.error('上传头像图片大小不能超过 1MB!');
      }
      return isJPG && isLt1M;

    },
    close() {
      this.init()
      this.DialogVisible = false
    },
    // 报修弹窗
    close2() {
      this.init()
      this.DialogVisible2 = false
    }
  }
}
</script>
<style lang="scss" scoped>
.containerManage {
  overflow-y: auto;
  box-sizing: border-box;
  width: calc(100% - 20px);
  .handle_box {
    margin-bottom: 20px;
    .el-select {
      margin: 0 5px;
    }
  }
  .el-table {
    .el-button + .el-button {
      margin-left: 0;
    }
  }

  .dialog_box {
    color: #324170;
    .el-button + .el-button {
      margin-left: 30px;
    }
    .top {
      .top_item {
        margin-bottom: 20px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 30px 0 20px;
      .icon1 {
        width: 3px;
        height: 15px;
        background: rgba(37, 181, 179, 1);
        margin-right: 3px;
      }
      .icon2 {
        width: 5px;
        height: 15px;
        background: rgba(37, 181, 179, 1);
        margin-right: 5px;
      }
    }
    .wrapper1 {
      margin: 10px 0;
      border-radius: 5px;
      background: rgba(1, 173, 168, 0.1);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .item {
        box-sizing: border-box;
        width: 48%;
        padding: 10px;
      }
      .item:nth-of-type(2),
      .item:nth-of-type(3) {
        width: 25%;
      }
    }
    .wrapper2 {
      margin: 10px 0;
      border-radius: 5px;
      background: rgba(1, 173, 168, 0.1);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .item {
        box-sizing: border-box;
        width: 33%;
        padding: 10px;
      }
      .item:last-of-type {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        align-items: flex-start;
        display: flex;
        .item_img {
          width: 100px;
          height: 100px;
          margin: 0 15px;
        }
      }
    }
  }
}
</style>